require('./referralsPromotionBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @utilities
const { BUTTON_TAGS, SECTION_NAME } = require('utilities/taggingReferralsHelper');
const { recordLink } = require('utilities/tagging');
// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
// @constants
const { getPublicSiteUrl } = require('core/apiURLBuilder');

class ReferralsPromotionBox extends React.Component {

    handleClickButton() {
        const { promotionSelected } = this.props;
        const processType = `${SECTION_NAME} - ${promotionSelected.get('title')}`;
        recordLink(processType, BUTTON_TAGS.REFER);
    }

    buildPromotionSection() {
        const { promotionSelected, publicId } = this.props;
        const promotionCode = promotionSelected.get('promotionCode');
        const moreInfoUrl = `${getPublicSiteUrl()}/node/${publicId || ''}`;
        let image;
        let subtitle;
        let title;
        let referButton;

        if (!!promotionSelected.get('imgUrl')) {
            image = <div className="referrals-promotion-box__image" style={{backgroundImage: `url(${promotionSelected.get('imgUrl')})`}} />
        }
        
        if (!!promotionSelected.get('title')) {
            title = (
                <h3 className="referrals-promotion-box__details-title">
                    {promotionSelected.get('title')}
                </h3>
            );
        }
        if (!!promotionSelected.get('subtitle')) {
            subtitle = (
                <p className="referrals-promotion-box__details-subtitle">
                    {promotionSelected.get('subtitle')}
                </p>
            );
        }

        const moreInfoLink = (
            <div className="referrals-promotion-box__details-more-info-link">
                <OKLink
                    modifier="editorial"
                    title={formatText("referrals-moreInfoTooltipText")}
                    to={moreInfoUrl}
                >
                    <FormattedText value="referrals-moreInfo" />
                </OKLink>
            </div>
        );
        const basesLink = promotionSelected.get('baseUrl') && (
            <div className="referrals-promotion-box__details-footer-bases-link">
                <OKLink
                    modifier="editorial"
                    target="_blank"
                    title={formatText("referrals-termsAndConditionsTooltipText")}
                    to={promotionSelected.get('baseUrl')}
                >
                    <FormattedText value="referrals-termsAndConditions" />
                </OKLink>
            </div>
        );

        if (!!promotionCode) {
            const referButtonLink = `/myprofile/referrals/form/${promotionCode}`;

            referButton = (
                <div className="referrals-promotion-box__details-footer-refer-button pull-right">
                    <OKButton
                        modifier="primary"
                        onClick={() => this.handleClickButton}
                        size="small"
                        to={referButtonLink}
                    >
                        <FormattedText value="referrals-refer" />
                    </OKButton>
                </div>
            );
        }

        return (
            <section
                className="referrals-promotion-box__promo-section"
                data-gtns-component-name={`${SECTION_NAME} - ${promotionCode}`}
            >
                <div className="referrals-promotion-box__wrapper-image">
                    {image}
                </div>
                <div className="referrals-promotion-box__details">
                    {title}
                    {subtitle}
                    {moreInfoLink}
                    <footer className="referrals-promotion-box__details-footer">
                        {basesLink}
                        {referButton}
                    </footer>
                </div>
            </section>
        )
    }

    render() {
        return this.buildPromotionSection();
    }
}

ReferralsPromotionBox.propTypes = {
    promotionSelected: PropTypes.object.isRequired,
    publicId: PropTypes.string
};

module.exports = ReferralsPromotionBox;
